import { mockResponse, request, isMockMode } from './client.js';

const MOCK_PLAYERS = [
  {
    slug: 'toru-suzuki',
    name: '鈴木 徹',
    en: 'TORU SUZUKI · #18 PDC ASIAN TOUR · 2024 TOP 16',
    eyebrow: 'SIGNATURE PLAYER · TARGET DARTS',
    bio: '日本選手鈴木徹是 TARGET SERENO 系列的長期合作夥伴。從業 15 年，以「中段重心、緻密環紋、高轉速擲法」聞名。2024 年於 PDC 亞洲巡迴賽連續 6 站打進 16 強。',
    stats: [
      { label: '3-DART AVG', value: '105.42' },
      { label: 'CHECKOUT', value: '47.8%' },
      { label: '180s / 場', value: '14' },
    ],
    intro: [
      '鈴木徹的擲鏢哲學受劍道影響甚深。他在 2007 年從劍道轉飛鏢，沿用「呼吸、定形、出鏢」的三段節奏。他與 TARGET 合作的 SERENO 系列總共出過兩代，目前 G2 是 2025 年最新版本。',
      '鈴木的代表性擲法是「高拋斜進」— 出手點高、軌跡帶弧度。這要求標身重心後移、握感扎實。G2 就是針對此擲法重新設計。',
    ],
    achievements: [
      'PDC 亞洲巡迴賽 2024 · 年度 TOP 16',
      'JAPAN OPEN 2024 · 男子單打第三名',
      'SOFT DARTS WORLD CUP 2024 · 日本代表',
      'PERFECT 全國巡迴 · 全季 8 站皆進入決賽圈',
    ],
    products: [
      { id: 'sereno-g2-23', name: 'SERENO G2 23g · Swiss Point', price: 1200 },
      { id: 'sereno-g2-21', name: 'SERENO G2 21g · Steel', price: 1180 },
      { id: 'sereno-g1', name: 'SERENO G1 限定回購', price: 980 },
    ],
  },
];

export function getPlayer(slug) {
  if (!isMockMode()) return request(`/players/${slug}`);
  return mockResponse(() => MOCK_PLAYERS.find(p => p.slug === slug) || MOCK_PLAYERS[0]);
}

export function getPlayers() {
  if (!isMockMode()) return request('/players');
  return mockResponse(MOCK_PLAYERS);
}
